/**
 * Array shape validator
 * Single Responsibility: type-guard a JSON value as a homogeneous
 * array of a single primitive type. Used by the favorites storage
 * layer to defensively reject malformed entries from localStorage.
 */

export const isStringArray = (raw: unknown): raw is string[] =>
  Array.isArray(raw) && raw.every((item): item is string => typeof item === 'string')

export const isNumberArray = (raw: unknown): raw is number[] =>
  Array.isArray(raw) && raw.every((item): item is number => typeof item === 'number')

export const isArrayOf = <T>(
  raw: unknown,
  predicate: (item: unknown) => item is T
): raw is T[] => Array.isArray(raw) && raw.every(predicate)
